module.exports = __webpack_public_path__ + "img/phone-office.602d8ce3.svg";